import Image from 'next/image';
import Link from 'next/link';

import { IResolvedBanner } from '@/src/utils/collections/banner.mapper';
import { IResolvedFaqCategory } from '@/src/utils/collections/faq/faq-categories.mappers';
import { InputSearchFaq } from '@/src/components/input-search-faq/InputSearchFaq';
import { InputSearchDestinations } from '@/src/components/input-search-destinations/InputSearchDestinations';
import { IZoneWithDestinationsAndPromo } from '@/src/modules/destinations/destinations.modules';
import { Button } from '@/src/components/ui/button';

interface IProps extends IResolvedBanner {
  destinations?: Record<string, IZoneWithDestinationsAndPromo>;
  faqItems?: IResolvedFaqCategory[];
  popularDestinations?: Record<string, IZoneWithDestinationsAndPromo>;
}

export const BannerImage = ({
  background,
  input,
  title,
  subtitle,
  text,
  destinations,
  faqItems,
  popularDestinations,
}: IProps) => {
  return (
    <div
      className={`relative mx-auto mb-8 h-[842px] w-full overflow-hidden lg:mb-14 lg:h-[680px]`}
    >
      {background.backgroundDesktop && (
        <Image
          src={background.backgroundDesktop.image}
          alt={background.backgroundDesktop?.alt || ''}
          placeholder={'blur'}
          blurDataURL={'/static/images/placeholder.webp'}
          objectFit={'cover'}
          fill
          loading={'eager'}
          priority
          className={'hidden object-cover md:block'}
        />
      )}
      {background.backgroundMobile && (
        <Image
          src={background.backgroundMobile.image}
          alt={background.backgroundMobile.alt || ''}
          placeholder={'blur'}
          blurDataURL={'/static/images/placeholder.webp'}
          className={'block object-cover md:hidden'}
          objectFit="cover"
          priority
          fill
          loading={'eager'}
        />
      )}
      <div
        className={`absolute inset-x-6 inset-y-[calc(100%/7)] mx-auto flex max-w-1200 flex-col gap-4 lg:inset-x-18`}
      >
        {title && (
          <div className={'max-w-xl text-4xl font-semibold lg:text-6xl'}>
            {title}
          </div>
        )}
        {subtitle && (
          <div className={'max-w-xl text-2xl lg:text-3xl'}>{subtitle}</div>
        )}
        {text && <div className={'max-w-xl text-lg'}>{text}</div>}
        {input.type === 'destinations' && destinations && (
          <div className={'w-full max-w-md'}>
            <InputSearchDestinations
              destinations={destinations}
              placeholder={input.placeholder}
              icon={input.icon}
              popularDestinations={popularDestinations}
            />
          </div>
        )}
        {input.type === 'faq' && faqItems && (
          <div className={'w-full'}>
            <InputSearchFaq
              faq={faqItems}
              placeholder={input.placeholder}
              icon={input.icon}
            />
          </div>
        )}
        {input.type === 'link' && (
          <Link
            href={input.link || ''}
            title={input.text || ''}
            rel={input.newTab ? 'noopener noreferrer' : ''}
            target={input.newTab ? '_blank' : ''}
            onClick={() => {
              window.dataLayer?.push({
                event: 'click_button',
                click_id: input.link,
                click_label: input.text,
              });
            }}
          >
            <Button className={'mt-8'} size={'md'}>
              {input.text || ''}
            </Button>
          </Link>
        )}
      </div>
    </div>
  );
};
